module.exports = __webpack_public_path__ + "static/around-the-way-girl-1dc30b2bcd3611e49fd35afbdd87b327.jpg";